import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseIcon from "@mui/icons-material/Close";

export interface PiModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  width: string;
  height: string;
  children?: React.ReactNode;
  onSubmit?: (...args: any[]) => void;
}

export default function PiModal(props: PiModalProps) {
  const { isOpen, onClose, width, height, title, children } = { ...props };

  const closeButton = (
    <div
      className={
        "absolute rounded-full top-[22px] right-[10px] text-creator-text hover:bg-interaction-primary-selected"
      }
    >
      <button onClick={onClose} className="p-2">
        <CloseIcon color={"inherit"} />
      </button>
    </div>
  );

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog className={"absolute z-[10000]"} onClose={onClose}>
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="flex fixed inset-0 justify-center items-center w-screen">
          <Dialog.Panel
            className="relative rounded-[5px] bg-creator-primary-background p-[20px] flex flex-col"
            style={{ width: width, height: height }}
          >
            <Dialog.Title
              className={
                "w-full font-bold border-b-2 border-solid h-[64px] text-creator-text text-[28px] border-creator-border"
              }
            >
              {title}
            </Dialog.Title>
            {closeButton}
            <div className={"overflow-y-hidden flex-1 pt-[12px]"}>
              {children}
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </Transition>
  );
}
